<div *ngIf="attrs.type==='sectionText'" style="height:30px;">
  <strong>
    --{{attrs.publishedName}}--
  </strong>
  <hr /><br />
</div>
<div class="form-group attr-width">
  <div *ngIf="attrs.type==='list' &&  attrs.show">
    <label for="{{attrs.publishedName}}" style="font-weight:bold">{{attrs.publishedName}}</label><br />
    <ng-container *ngFor="let option of attrs.options;let optionIndex=index">
      <ng-container *ngIf="option.value===attrs.value"><label>{{option.description}}</label></ng-container>
    </ng-container>
  </div>
  <div *ngIf="attrs.type==='text' &&  attrs.show">
    <label for="{{attrs.publishedName}}" style="font-weight:bold">{{attrs.publishedName}}</label><br />
    <label>{{attrs.value}}</label>
  </div>
  <div *ngIf="attrs.type==='number' &&  attrs.show">
    <label for="{{attrs.publishedName}}" style="font-weight:bold">{{attrs.publishedName}}</label><br />
    <label>{{attrs.value}}</label>
  </div>
  <div *ngIf="attrs.type==='switch' &&  attrs.show" class="form-inline">
    <kendo-switch onLabel="Yes" offLabel="No"  [(ngModel)]="checked" [disabled]="true">
    </kendo-switch>&nbsp;&nbsp;
    <label class="k-checkbox-label" for="ch5">{{attrs.publishedName}}</label>
  </div>
  <div *ngIf="attrs.type==='radio' && attrs.show">
    <input type="radio"
           id="foo" name="a"
           [(ngModel)]="attrs.value"
           [value]="'Non-Transom'"
           [disabled]="true"
           kendoRadioButton *ngIf="attrs.options[0].show" />
    <label class="k-radio-label" for="foo" *ngIf="attrs.options[0].show">{{attrs.options[0].description}}</label>
    <input type="radio" id="foo1" name="a"
           [(ngModel)]="attrs.value"
           [value]="'Transom'"
           [disabled]="true"
           kendoRadioButton *ngIf="attrs.options[1].show" />
    <label class="k-radio-label" for="foo1" *ngIf="attrs.options[1].show">{{attrs.options[1].description}}</label>
  </div>
</div>

